var _circle, _circle2, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 149,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 74.5,
    r: 74.5,
    fill: "#0b75c2",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 74.5,
    r: 58.752,
    fill: "#0b75c2",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87.222,
    height: 87.224,
    x: 31.496,
    y: 30.285,
    fill: "#0b75c2",
    rx: 43.611
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.36 56.98q-.622-.045-1.247-.045v-2.423q.714 0 1.427.053zm4.856 1.091q-1.167-.45-2.387-.724l.53-2.365c.929.209 1.842.485 2.729.829zm3.319 1.72q-.52-.346-1.064-.654l1.195-2.108q1.243.706 2.372 1.585l-1.49 1.911q-.494-.384-1.013-.731zm4.443 4.337a17 17 0 0 0-1.582-1.928l1.754-1.672c.654.69 1.26 1.43 1.81 2.205zm1.803 3.276a17 17 0 0 0-.519-1.134l2.164-1.09q.643 1.277 1.09 2.635l-2.302.759q-.195-.593-.433-1.17m1.284 6.074a17 17 0 0 0-.242-2.484l2.386-.412c.162.936.257 1.885.281 2.835l-2.423.06h-.002zm-.317 3.726q.12-.617.196-1.236l2.406.298q-.176 1.42-.558 2.798l-2.335-.646q.167-.6.29-1.214zm-2.307 5.764a17 17 0 0 0 1.177-2.2l2.215.98a19.6 19.6 0 0 1-1.345 2.516zm-2.335 2.919q.444-.444.847-.916l1.837 1.582q-.467.54-.972 1.047z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M75.113 56.935a16.96 16.96 0 0 0-3.307 33.593 16.96 16.96 0 0 0 15.3-4.641l1.713 1.713a19.385 19.385 0 1 1-13.706-33.088z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.901 61.78a1.21 1.21 0 0 1 1.212 1.212v12.622l7.869 4.497a1.211 1.211 0 0 1-1.202 2.103l-8.48-4.846a1.21 1.21 0 0 1-.61-1.051V62.992a1.21 1.21 0 0 1 1.21-1.212z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.56a47fb2073b1ab2c872475b4df7ad3b.svg";
export { ForwardRef as ReactComponent };